// src/common/utils/countryNameMapper.ts

export const COUNTRY_NAMES: Record<string, string> = {
  US: "United States",
  CA: "Canada",
  IN: "India",
  AU: "Australia",
  GB: "United Kingdom",
  DE: "Germany",
  FR: "France",
  BR: "Brazil",
  MX: "Mexico",
  CN: "China",
  JP: "Japan",
  RU: "Russia",
};

export function getCountryFullName(countryCode: string): string {
  if (!countryCode) return countryCode;
  return COUNTRY_NAMES[countryCode] || countryCode;
}
